import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AutocompleteSuggestion } from '~/component/form/autocomplete/interfaces/suggestion.interface';
import { InputStyleEnum } from '~/component/form/input/enums/style.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { diacriticSort } from '~/core/helpers/sort/diacritic-sort.helper';
import { SportsService } from '~/core/services/sports/sports.service';

@Component({
  selector: 'app-attendee-sports-groups-autocomplete',
  templateUrl: './sports-groups-autocomplete.component.html',
})
export class AttendeeSportsGroupsAutocompleteComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() public ariaLabel: string;
  @Input() public inputStyle = InputStyleEnum.Shadowed;
  @Input() public label?: string;
  @Input() public placeholder: string;
  @Input() public selectedIdentifier?: number;

  @Output() public selected = new EventEmitter();

  private readonly subscription = new Subscription();

  public readonly iconType = VtmnPlayIconTypeEnum;

  public sport = new FormControl();
  public suggestions: AutocompleteSuggestion[] = [];

  constructor(private readonly sportsService: SportsService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.selectedIdentifier.currentValue !==
      changes.selectedIdentifier.previousValue
    ) {
      if (!changes.selectedIdentifier.currentValue) {
        this.sport.setValue(null);
        return;
      }

      this.sport.setValue({
        selected: true,
        text: this.getGroupText(changes.selectedIdentifier.currentValue),
        value: changes.selectedIdentifier.currentValue,
      });
    }
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngOnInit(): void {
    // API Call
    this.sportsService.getSportsGroups().subscribe((groups) => {
      // generate sorted sugestion
      this.suggestions = groups
        .map((group) => {
          return {
            selected: group.id === +this.selectedIdentifier,
            text: group.label,
            value: group.id,
          };
        })
        .sort(({ text: currentValue }, { text: nextValue }) =>
          diacriticSort(currentValue, nextValue)
        );

      if (this.selectedIdentifier) {
        this.sport.setValue({
          selected: true,
          text: this.getGroupText(this.selectedIdentifier),
          value: this.selectedIdentifier,
        });
      }
    });

    // value change
    this.subscription.add(
      this.sport.valueChanges.subscribe((item) => {
        this.selected.emit({
          sportsGroupId: item?.value || null,
          sportsGroupName: item?.value ? this.getGroupText(item.value) : null,
        });
      })
    );
  }

  public get customLabelClass(): string {
    return (
      this.inputStyle === InputStyleEnum.Transparent &&
      'font-bold text-grey-dark-3 text-base'
    );
  }

  public getGroupText(groupId: number): string {
    return this.suggestions.find((s) => s.value === +groupId)?.text;
  }

  public preventLabelBehaviour(event: MouseEvent): void {
    event.preventDefault();
  }

  public selectSportItem(item: {
    selected: string;
    text: string;
    value: string;
  }): void {
    const text = item.text;

    this.sport.setValue({
      selected: true,
      text,
      value: item.value,
    });
  }
}
